package org.multipaz.utopia.generated

/**
 * Generated strings for language: he
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
internal val strings_he = mapOf(
    "boarding_pass_attribute_departure_time" to "שעת יציאה",
    "boarding_pass_attribute_flight_number" to "מספר טיסה",
    "boarding_pass_attribute_passenger_name" to "שם נוסע",
    "boarding_pass_attribute_seat_number" to "מספר מושב",
    "boarding_pass_description_departure_time" to "תאריך ושעת היציאה",
    "boarding_pass_description_flight_number" to "מספר הטיסה",
    "boarding_pass_description_passenger_name" to "שם משפחה, או מזהה ראשי, של בעל ה-mDL.",
    "boarding_pass_description_seat_number" to "מספר המושב",
    "cor_attribute_administrative_number" to "מספר מנהלי",
    "cor_attribute_date_of_arrival" to "תאריך הגעה",
    "cor_attribute_date_of_birth" to "תאריך לידה",
    "cor_attribute_date_of_expiry" to "תאריך תפוגה",
    "cor_attribute_date_of_issue" to "תאריך הנפקה",
    "cor_attribute_document_number" to "מספר מסמך",
    "cor_attribute_family_name" to "שם משפחה",
    "cor_attribute_gender" to "מין",
    "cor_attribute_given_names" to "שמות פרטיים",
    "cor_attribute_issuing_authority" to "רשות מנפיקה",
    "cor_attribute_issuing_country" to "מדינה מנפיקה",
    "cor_attribute_issuing_jurisdiction" to "תחום שיפוט מנפיק",
    "cor_attribute_nationality" to "אזרחות",
    "cor_attribute_older_than_18" to "מבוגר מ-18",
    "cor_attribute_older_than_21" to "מבוגר מ-21",
    "cor_attribute_place_of_birth" to "מקום לידה",
    "cor_attribute_resident_address" to "כתובת מגורים",
    "cor_attribute_resident_city" to "עיר מגורים",
    "cor_attribute_resident_country" to "מדינת מגורים",
    "cor_attribute_resident_house_number" to "מספר בית מגורים",
    "cor_attribute_resident_postal_code" to "מיקוד מגורים",
    "cor_attribute_resident_state" to "מחוז מגורים",
    "cor_attribute_resident_street" to "רחוב מגורים",
    "cor_description_administrative_number" to "מספר שהוקצה על ידי ספק ה-COR לצורך בקרת ביקורת או מטרות אחרות.",
    "cor_description_date_of_arrival" to "יום, חודש ושנה שבהם בעל ה-COR הגיע לאיחוד האירופי.",
    "cor_description_date_of_birth" to "יום, חודש ושנה שבהם נולד בעל ה-COR. אם לא ידוע, תאריך לידה משוער.",
    "cor_description_date_of_expiry" to "תאריך (ואולי שעה) שבו תוקף ה-COR יפוג.",
    "cor_description_date_of_issue" to "תאריך (ואולי שעה) שבו ה-COR הונפק.",
    "cor_description_document_number" to "מספר עבור ה-COR, שהוקצה על ידי ספק ה-COR.",
    "cor_description_family_name" to "שם(שמות) המשפחה הנוכחי(ים), או המזהה הראשי של בעל ה-COR",
    "cor_description_gender" to "מגדר של בעל ה-COR.",
    "cor_description_given_names" to "שם(שמות) פרטי(ים) נוכחי(ים), שם(שמות) אחר(ים) או מזהה משני של בעל ה-COR",
    "cor_description_issuing_authority" to "שם הרשות המנהלית שהנפיקה מופע COR זה, או קוד המדינה ISO 3166 אלפא-2 של המדינה החברה הרלוונטית אם אין רשות נפרדת המוסמכת להנפיק CORs.",
    "cor_description_issuing_country" to "קוד מדינה אלפא-2, כפי שהוגדר ב-ISO 3166-1, של המדינה או הטריטוריה של הרשות המנפיקה",
    "cor_description_issuing_jurisdiction" to "קוד חלוקת משנה של מדינה של תחום השיפוט שהנפיק את ה-COR, כפי שהוגדר ב-ISO 3166-2:2020, סעיף 8. החלק הראשון של הקוד יהיה זהה לערך עבור issuing_country.",
    "cor_description_nationality" to "קוד מדינה אלפא-2 כפי שמפורט ב-ISO 3166-1, המייצג את לאום המשתמש.",
    "cor_description_older_than_18" to "גיל מעל 18?",
    "cor_description_older_than_21" to "גיל מעל 21?",
    "cor_description_place_of_birth" to "מקום הלידה של בעל ה-COR.",
    "cor_description_resident_address" to "הכתובת המלאה של המקום שבו בעל ה-COR מתגורר כעת ו/או ניתן ליצור עמו קשר (רחוב/מספר בית, עירייה וכד')",
    "cor_description_resident_city" to "העיר שבה בעל ה-COR מתגורר כרגע.",
    "cor_description_resident_country" to "המדינה שבה המשתמש מתגורר כעת, כקוד מדינה אלפא-2 כמפורט בתקן ISO 3166-1",
    "cor_description_resident_house_number" to "מספר הבית שבו המשתמש מתגורר כרגע, כולל קידומת או סיומת.",
    "cor_description_resident_postal_code" to "המיקוד של המקום שבו בעל ה-COR מתגורר כרגע.",
    "cor_description_resident_state" to "המדינה, המחוז, הנפה או האזור שבו המשתמש מתגורר כיום.",
    "cor_description_resident_street" to "שם הרחוב שבו המשתמש מתגורר כרגע.",
    "cor_request_age_over_18" to "גיל מעל 18",
    "cor_request_all_data_elements" to "כל רכיבי הנתונים",
    "cor_request_mandatory_data_elements" to "רכיבי נתונים נדרשים",
    "document_display_name_boarding_pass" to "כרטיס עלייה למטוס",
    "document_display_name_certificate_of_residency" to "תעודת תושבות",
    "document_display_name_german_personal_id" to "תעודת זהות גרמנית",
    "document_display_name_loyalty_card" to "כרטיס מועדון",
    "document_display_name_movie_ticket" to "כרטיס קולנוע",
    "document_display_name_naturalization_certificate" to "תעודת התאזרחות",
    "document_display_name_payment_card" to "כרטיס תשלום",
    "german_id_attribute_administrative_number" to "מספר מנהלי",
    "german_id_attribute_age_in_years" to "גיל בשנים",
    "german_id_attribute_city_of_birth" to "עיר לידה",
    "german_id_attribute_country_of_birth" to "מדינת לידה",
    "german_id_attribute_date_of_birth" to "תאריך לידה",
    "german_id_attribute_date_of_expiry" to "תאריך תפוגה",
    "german_id_attribute_date_of_issue" to "תאריך הנפקה",
    "german_id_attribute_document_number" to "מספר מסמך",
    "german_id_attribute_family_name" to "שם משפחה",
    "german_id_attribute_family_name_at_birth" to "שם משפחה בלידה",
    "german_id_attribute_gender" to "מגדר",
    "german_id_attribute_given_names" to "שמות פרטיים",
    "german_id_attribute_issuing_authority" to "רשות מנפיקה",
    "german_id_attribute_issuing_country" to "מדינה מנפיקה",
    "german_id_attribute_issuing_jurisdiction" to "תחום שיפוט מנפיק",
    "german_id_attribute_nationality" to "אזרחות",
    "german_id_attribute_older_than_12" to "מבוגר מ-12",
    "german_id_attribute_older_than_14" to "מבוגר מ-14",
    "german_id_attribute_older_than_16" to "מעל גיל 16",
    "german_id_attribute_older_than_18" to "מעל גיל 18",
    "german_id_attribute_older_than_21" to "מעל גיל 21",
    "german_id_attribute_older_than_65" to "מעל גיל 65",
    "german_id_attribute_place_of_birth" to "מקום לידה",
    "german_id_attribute_resident_address" to "כתובת מגורים",
    "german_id_attribute_resident_city" to "עיר מגורים",
    "german_id_attribute_resident_country" to "מדינת מגורים",
    "german_id_attribute_resident_postal_code" to "מיקוד מגורים",
    "german_id_attribute_state_of_birth" to "מחוז לידה",
    "german_id_attribute_year_of_birth" to "שנת לידה",
    "german_id_description_administrative_number" to "מספר שהוקצה על ידי ספק ה-PID לצורכי בקרת ביקורת או מטרות אחרות.",
    "german_id_description_age_in_years" to "גיל מחזיק ה-PID בשנים",
    "german_id_description_city_of_birth" to "הרשות המקומית, העיר, העיירה או הכפר שבהם נולד בעל ה-PID",
    "german_id_description_country_of_birth" to "המדינה שבה נולד משתמש ה-PID, כקוד מדינה בן 2 אותיות (Alpha-2) כמפורט ב-ISO 3166-1",
    "german_id_description_date_of_birth" to "יום, חודש ושנה בהם נולד מחזיק ה-PID. אם לא ידוע, תאריך לידה משוער.",
    "german_id_description_date_of_expiry" to "התאריך (ואולי גם השעה) שבו יפוג תוקפו של ה-PID.",
    "german_id_description_date_of_issue" to "התאריך (ואולי גם השעה) שבו הונפק ה-PID.",
    "german_id_description_document_number" to "מספר עבור ה-PID, שהוקצה על ידי ספק ה-PID.",
    "german_id_description_family_name" to "שם/שמות משפחה נוכחי/ים, או מזהה עיקרי של מחזיק ה-PID",
    "german_id_description_family_name_at_birth" to "שם/שמות משפחה, או מזהה עיקרי של מחזיק ה-PID בלידה",
    "german_id_description_gender" to "מגדר בעל ה-PID",
    "german_id_description_given_names" to "שם/שמות פרטי/ים נוכחי/ים, שם/שמות אחר/ים, או מזהה משני של מחזיק ה-PID",
    "german_id_description_issuing_authority" to "שם הרשות המנהלית שהנפיקה את עותק ה-PID הזה, או קוד המדינה אלפא-2 של ISO 3166 של המדינה החברה המתאימה אם אין רשות נפרדת המוסמכת להנפיק PIDs.",
    "german_id_description_issuing_country" to "קוד מדינה Alpha-2, כפי שהוגדר בתקן ISO 3166-1, של המדינה או הטריטוריה של הרשות המנפיקה.",
    "german_id_description_issuing_jurisdiction" to "קוד חלוקה מנהלית של המדינה של תחום השיפוט שהנפיק את ה-PID, כפי שהוגדר בתקן ISO 3166-2:2020, סעיף 8. החלק הראשון של הקוד יהיה זהה לערך של issuing_country.",
    "german_id_description_nationality" to "רשימת קודי מדינות אלפא-2 כפי שמפורט ב-ISO 3166-1, המייצגים את לאומיותו של משתמש ה-PID.",
    "german_id_description_older_than_12" to "גיל מעל 12?",
    "german_id_description_older_than_14" to "גיל מעל 14?",
    "german_id_description_older_than_16" to "גיל מעל 16?",
    "german_id_description_older_than_18" to "גיל מעל 18?",
    "german_id_description_older_than_21" to "גיל מעל 21?",
    "german_id_description_older_than_65" to "גיל מעל 65?",
    "german_id_description_place_of_birth" to "מדינה ועירייה, או מחוז/פרובינציה, שבהם נולד מחזיק ה-PID",
    "german_id_description_resident_address" to "הכתובת המלאה של מקום מגוריו הנוכחי של בעל ה-PID ו/או מקום שבו ניתן ליצור עמו קשר (רחוב/מספר בית, רשות מקומית וכו')",
    "german_id_description_resident_city" to "העיר שבה מתגורר כרגע בעל ה-PID",
    "german_id_description_resident_country" to "המדינה שבה מתגורר כרגע משתמש ה-PID, כקוד מדינה אלפא-2 כפי שמפורט ב-ISO 3166-1",
    "german_id_description_resident_postal_code" to "המיקוד של מקום מגוריו הנוכחי של בעל ה-PID",
    "german_id_description_state_of_birth" to "המדינה, המחוז, הנפה, או האזור המקומי שבהם נולד משתמש ה-PID",
    "german_id_description_year_of_birth" to "שנת הלידה של מחזיק ה-PID",
    "german_id_request_age_over_18" to "מעל גיל 18",
    "german_id_request_all_data_elements" to "כל רכיבי המידע",
    "german_id_request_mandatory_data_elements" to "רכיבי מידע חובה",
    "loyalty_attribute_date_of_expiry" to "תאריך תפוגה",
    "loyalty_attribute_date_of_issue" to "תאריך הנפקה",
    "loyalty_attribute_family_name" to "שם משפחה",
    "loyalty_attribute_given_names" to "שמות פרטיים",
    "loyalty_attribute_membership_id" to "מספר חבר",
    "loyalty_attribute_photo_of_holder" to "תמונת בעל הכרטיס",
    "loyalty_attribute_tier" to "דרגה",
    "loyalty_description_date_of_expiry" to "תאריך תפוגת המסמך",
    "loyalty_description_date_of_issue" to "תאריך הנפקת המסמך",
    "loyalty_description_family_name" to "שם משפחה, או מזהה ראשי, של בעל המסמך",
    "loyalty_description_given_names" to "שם פרטי (שמות פרטיים), שמות נוספים, או מזהה משני, של בעל המסמך",
    "loyalty_description_membership_id" to "מזהה אדם של בעל תעודת המועדון.",
    "loyalty_description_photo_of_holder" to "העתק של תמונת הפרופיל של בעל המסמך.",
    "loyalty_description_tier" to "דרגת חברות (בסיסית, כסף, זהב, פלטינה, עילית)",
    "loyalty_request_all_data_elements" to "כל פריטי המידע",
    "loyalty_request_mandatory_data_elements" to "פריטי מידע חובה",
    "movie_ticket_attribute_age_rating_code" to "קוד דירוג גילאים",
    "movie_ticket_attribute_cinema_theater" to "בית קולנוע",
    "movie_ticket_attribute_date_and_time_of_show" to "תאריך ושעת ההצגה",
    "movie_ticket_attribute_movie_poster" to "פוסטר סרט",
    "movie_ticket_attribute_movie_title" to "שם הסרט",
    "movie_ticket_attribute_parking" to "חניה",
    "movie_ticket_attribute_seat" to "מושב",
    "movie_ticket_attribute_theater" to "אולם",
    "movie_ticket_attribute_ticket_number" to "מספר כרטיס",
    "movie_ticket_description_age_rating_code" to "קוד דירוג סרט להגבלות גיל.",
    "movie_ticket_description_cinema_theater" to "שם בית הקולנוע/אולם, ו/או כתובת/מיקום הכניסה.",
    "movie_ticket_description_date_and_time_of_show" to "תאריך ושעת תחילת הסרט",
    "movie_ticket_description_movie_poster" to "פוסטר הסרט",
    "movie_ticket_description_movie_title" to "שם הסרט, כותרתו, וכל מידע זיהוי אחר של ההצגה.",
    "movie_ticket_description_parking" to "סימון אם חניית רכב שולמה מראש יחד עם רכישת הכרטיס.",
    "movie_ticket_description_seat" to "מספר או קוד המושב (לדוגמה: שורה/מושב).",
    "movie_ticket_description_theater" to "שם או מספר האולם בבניין קולנוע מרובה אולמות.",
    "movie_ticket_description_ticket_number" to "מספר זיהוי/אסמכתא של הכרטיס שהונפק בעת הרכישה.",
    "movie_ticket_request_all_data_elements" to "כל רכיבי הנתונים",
    "movie_ticket_request_prepaid_parking" to "חניה בתשלום מראש",
    "movie_ticket_request_ticket_number" to "מספר כרטיס",
    "naturalization_attribute_date_of_birth" to "תאריך לידה",
    "naturalization_attribute_date_of_naturalization" to "תאריך התאזרחות",
    "naturalization_attribute_family_name" to "שם משפחה",
    "naturalization_attribute_given_names" to "שמות פרטיים",
    "naturalization_description_date_of_birth" to "יום, חודש ושנה שבהם נולד המתאזרח. אם לא ידוע, תאריך לידה משוער.",
    "naturalization_description_date_of_naturalization" to "תאריך (ואולי שעה) שבהם האדם התאזרח.",
    "naturalization_description_family_name" to "שם(שמות) המשפחה הנוכחי(ים) או מזהה ראשי של המתאזרח",
    "naturalization_description_given_names" to "שם(שמות) פרטי(ים) נוכחי(ים), שם(שמות) אחר(ים), או מזהה משני של המתאזרח",
    "naturalization_request_all_data_elements" to "כל רכיבי הנתונים",
    "payment_attribute_expiry_date" to "תאריך תפוגה",
    "payment_attribute_holder_name" to "שם בעל הכרטיס",
    "payment_attribute_issue_date" to "תאריך הנפקה",
    "payment_attribute_issuer_name" to "שם המנפיק",
    "payment_attribute_masked_account_reference" to "הפניית חשבון מוסווה",
    "payment_attribute_payment_instrument_id" to "מזהה אמצעי תשלום",
    "payment_description_expiry_date" to "תאריך תפוגת אישור זה.",
    "payment_description_holder_name" to "שם בעל חשבון התשלום.",
    "payment_description_issue_date" to "תאריך הנפקת אישור זה.",
    "payment_description_issuer_name" to "שם מנפיק קריא.",
    "payment_description_masked_account_reference" to "הפניית חשבון ממוסכת, לדוגמה 4 ספרות אחרונות של PAN.",
    "payment_description_payment_instrument_id" to "מזהה אמצעי תשלום שעבר טוקניזציה.",
    "payment_request_payment_sca_all" to "אימות לקוח חזק לתשלום (כל רכיבי הנתונים)",
    "payment_request_payment_sca_minimal" to "אימות לקוח חזק לתשלום (מינימלי)",
    "payment_request_payment_sca_transaction" to "SCA עם עסקת תשלום"
)
